// extracted by mini-css-extract-plugin
export var errorIcon = "_j6-1";
export var nameLogo = "_j6-0";